const burger = document.getElementById('burger');
const menu = document.getElementById('menu');

if(burger && menu) {
    burger.addEventListener('click', () => {
        if(burger.classList.contains('open')) {
            burger.classList.remove('open');
            menu.classList.remove('open');
        } else {
            burger.classList.add('open');
            menu.classList.add('open');
        }
    });
}

document.querySelectorAll('a[href^="#"]:not(.loadMore):not(.loadMoreEvents)').forEach(anchor =>
{
    anchor.addEventListener('click', function (e)
    {
        e.preventDefault();

        if(!anchor.classList.contains('loadmore')) {
            document?.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        }
    });
});

let scrollPosition = window.scrollY;
const mobMenu = document.getElementById("mobMenu");
const header = document.getElementById("header");

window.addEventListener('scroll', function() {
    scrollPosition = window.scrollY;
    if(scrollPosition >= 90) {
        header.classList.add('header__small');
    } else {
        header.classList.remove('header__small');
    }
});

mobMenu.addEventListener("click", () =>
{
    if(header.classList.contains("open"))
    {
        header.classList.remove("open");
        mobMenu.innerText = "Menu";
    }
    else
    {
        header.classList.add("open");
        mobMenu.innerText = "Close";
    }
});


